// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { SecondaryButton } from '@/views/components/buttons';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  activeFiltersCount?: number;
  isActive?: boolean;
  onClick: () => void;
  className?: string;
};

/**
 * Filter button component for screener.
 * Shows a filter icon with label and optional pill badge showing active filter count.
 * The button can be in an active state (blue) when filters are being shown.
 */
const FilterButton = ({ activeFiltersCount = 0, isActive = false, onClick, className }: Props) => {
  const hasActiveFilters = activeFiltersCount > 0;

  return (
    <SecondaryButton
      className={classNames('filter-button', className, {
        'has-active-filters': hasActiveFilters,
        'is-active': isActive,
      })}
      onClick={onClick}
      icon="ds-filter-alt"
    >
      <span className="filter-label">{formatMessage('Screener.Filter.Button')}</span>
      {hasActiveFilters && (
        <div className="filter-count-pill">
          <span>{activeFiltersCount}</span>
        </div>
      )}
    </SecondaryButton>
  );
};

export default FilterButton;
